export default {
    WARNING_DUPLICATE: 'В магазине найден дубликат ключа от товара:',
    INVALID_STORE: 'Попытка разобрать несуществующий магазин.',
    INVALID_STORE_REFRESH: 'Попытался обновить недействительный магазин:',
    INVALID_ITEM_SELECTION: 'Неверный выбор элемента.',
    PURCHASE_INVALID_STORE: 'пытались приобрести товар, которого нет в магазине:',
    SELL_INVALID_ITEM: 'попытка продать недействительный товар.',
    ITEM_OUT_OF_STOCK: 'В настоящее время этот товар отсутствует на складе.',
    NOT_ENOUGH_CURRENCY: 'У вас недостаточно валюты для покупки этого товара.',
    NOT_ENOUGH_SPACE: 'В инвентаре не хватает места.',
    CANNOT_SELL_ITEM: 'Вы не можете продать этот товар.',
    ACTION_STORE_NOT_OPEN: 'Попытался выполнить действие для магазина, который не открыт.',
    CHEATER: 'Вы были отмечены за мошенничество. Вы не можете ничего приобрести.',
    RESTRICTED_STORE: 'Этот магазин не принимает никаких товаров.',
    RESTRICTED_ITEM: 'Этот товар не может быть продан здесь.',
    INVALID_ITEM_COUNT: 'Вы ввели недопустимое количество товаров.',
    HOLLOW_ADMIN: 'Как администратор вы не можете взаимодействовать с экономикой.'
} as const;
